<div *transloco="let t; prefix: 'property-listing.construction'" [formGroup]="constructionFormGroup" class="flex-1">
  <div class="flex flex-col rfs:gap-[72px]">
    <div class="flex flex-col gap-6">
      <h2 class="h2 text-black">{{ 'property-listing.tabs.heatingAndConstruction' | transloco }}</h2>
    </div>

    <div class="flex flex-col">
      <h3 class="h3 text-black mb-6">{{ t('subheaders.heating') }}</h3>
      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
        {{ t('labels.heatingType') }}
      </div>
      <div class="flex flex-row gap-4 flex-wrap mb-6">
        <label class="visual-checkbox flex flex-col" for="naturalGas">
          <input
            (click)="constructionFormGroup.controls.heatingType.setValue(constructionFormGroup.controls.heatingType.value === heatingType.NaturalGas ? null : heatingType.NaturalGas)"
            [checked]="constructionFormGroup.controls.heatingType.value === heatingType.NaturalGas"
            class="opacity-0 absolute h-0 w-0"
            id="naturalGas"
            type="checkbox">
          <span class="">{{ 'shared.enum.heatingType.' + heatingType.NaturalGas | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="heatingOil">
          <input
            (click)="constructionFormGroup.controls.heatingType.setValue(constructionFormGroup.controls.heatingType.value === heatingType.HeatingOil ? null : heatingType.HeatingOil)"
            [checked]="constructionFormGroup.controls.heatingType.value === heatingType.HeatingOil"
            class="opacity-0 absolute h-0 w-0"
            id="heatingOil"
            type="checkbox">
          <span class="">{{ 'shared.enum.heatingType.' + heatingType.HeatingOil | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="heatPump">
          <input
            (click)="constructionFormGroup.controls.heatingType.setValue(constructionFormGroup.controls.heatingType.value === heatingType.HeatPump ? null : heatingType.HeatPump)"
            [checked]="constructionFormGroup.controls.heatingType.value === heatingType.HeatPump"
            class="opacity-0 absolute h-0 w-0"
            id="heatPump"
            type="checkbox">
          <span class="">{{ 'shared.enum.heatingType.' + heatingType.HeatPump | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="electricAirConditioning">
          <input
            (click)="constructionFormGroup.controls.heatingType.setValue(constructionFormGroup.controls.heatingType.value === heatingType.ElectricAirConditioning ? null : heatingType.ElectricAirConditioning)"
            [checked]="constructionFormGroup.controls.heatingType.value === heatingType.ElectricAirConditioning"
            class="opacity-0 absolute h-0 w-0"
            id="electricAirConditioning"
            type="checkbox">
          <span class="">{{ 'shared.enum.heatingType.' + heatingType.ElectricAirConditioning | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="other">
          <input
            (click)="constructionFormGroup.controls.heatingType.setValue(constructionFormGroup.controls.heatingType.value === heatingType.None ? null : heatingType.None)"
            [checked]="constructionFormGroup.controls.heatingType.value === heatingType.None"
            class="opacity-0 absolute h-0 w-0"
            id="other"
            type="checkbox">
          <span class="">{{ 'shared.enum.heatingType.' + heatingType.None | transloco }}</span>
        </label>
      </div>

      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
        {{ t('labels.heatingControl') }}
      </div>
      <div class="flex xl:flex-row flex-col xl:items-center items-start gap-4 mb-10">
        <div class="flex-1 border border-gray-300 rounded-lg p-4">
          <label class="radio-selector secondary" for="radio-selector-heating-autonomous" role="button">
            <input
              (click)="constructionFormGroup.controls.heatingControl.setValue(constructionFormGroup.controls.heatingControl.value === heatingControl.Autonomous ? null : heatingControl.Autonomous)"
              [checked]="constructionFormGroup.controls.heatingControl.value === heatingControl.Autonomous"
              class="hidden"
              id="radio-selector-heating-autonomous"
              name="heatingControl"
              type="radio">
            <div class="radio-selector-content">
            <span
              class="radio-selector-text font-semibold">{{ 'shared.enum.heatingControl.' + heatingControl.Autonomous | transloco }}</span>
              <span class="radio-selector-text font-normal text-gray-700 text-sm">
                            {{ t('helperText.heatingControlAutonomous') }}
                        </span>
            </div>
          </label>
        </div>
        <div class="flex-1 border border-gray-300 rounded-lg p-4">
          <label class="radio-selector secondary" for="radio-selector-radio-2" role="button">
            <input
              (click)="constructionFormGroup.controls.heatingControl.setValue(constructionFormGroup.controls.heatingControl.value === heatingControl.Central ? null : heatingControl.Central)"
              [checked]="constructionFormGroup.controls.heatingControl.value === heatingControl.Central" class="hidden"
              id="radio-selector-radio-2" name="heatingControl" type="radio">
            <div class="radio-selector-content">
            <span
              class="radio-selector-text font-semibold">{{ 'shared.enum.heatingControl.' + heatingControl.Central | transloco }}</span>
              <span class="radio-selector-text font-normal text-gray-700 text-sm">
                            {{ t('helperText.heatingControlCentral') }}
                        </span>
            </div>
          </label>
        </div>
      </div>

      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
        {{ t('labels.energyClass') }}
        <i class="icon-info-circle text-gray-700 text-xl"></i>
      </div>
      <div class="my-6">
        <label class="inline-flex items-center cursor-pointer">
          <input class="sr-only peer toggle-input" type="checkbox" [checked]="showEnergyRating" (change)="onCheckboxChange($event)" >
          <div
            class="toggle-visual relative w-12 h-8 bg-gray-400 hover:bg-gray-300 peer-disabled:bg-gray-100 transition-all rounded-full peer peer-checked:after:translate-x-[16px] rtl:peer-checked:after:-translate-x-[16px] after:absolute after:top-[1px] after:start-[1px] after:bg-white after:rounded-full after:h-[30px] after:w-[30px] after:transition-all peer-disabled:after:bg-gray-300 peer-checked:after:text-primary-600 peer-checked:bg-primary-600"></div>
          <div class="flex flex-col">
            <span
              class="ms-4 text-sm text-gray-800">{{ t('labels.energyClassCertificateAvailable') }}</span>
          </div>
        </label>
      </div>
      <div *ngIf="showEnergyRating" class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-9 gap-4">
        <label class="visual-checkbox flex flex-col" for="energyClassAPlus">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.APlus ? null : energyClass.APlus)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.APlus"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassAPlus"
            type="checkbox">
          <span class=" font-semibold">{{ 'shared.enum.energyClass.' + energyClass.APlus | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassA">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.A ? null : energyClass.A)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.A"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassA"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.A | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassBPlus">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.BPlus ? null : energyClass.BPlus)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.BPlus"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassBPlus"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.BPlus | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassB">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.B ? null : energyClass.B)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.B"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassB"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.B | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassC">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.C ? null : energyClass.C)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.C"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassC"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.C | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassD">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.D ? null : energyClass.D)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.D"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassD"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.D | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassE">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.E ? null : energyClass.E)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.E"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassE"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.E | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassF">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.F ? null : energyClass.F)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.F"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassF"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.F | transloco }}</span>
        </label>
        <label class="visual-checkbox flex flex-col" for="energyClassG">
          <input
            (click)="constructionFormGroup.controls.energyClass.setValue(constructionFormGroup.controls.energyClass.value === energyClass.G ? null : energyClass.G)"
            [checked]="constructionFormGroup.controls.energyClass.value === energyClass.G"
            class="opacity-0 absolute h-0 w-0"
            formcontrolName="energyClass"
            id="energyClassG"
            type="checkbox">
          <span class="font-semibold">{{ 'shared.enum.energyClass.' + energyClass.G | transloco }}</span>
        </label>
      </div>
    </div>

    <div class="flex flex-col">
      <h3 class="h3 text-black mb-6">{{ t('subheaders.construction') }}</h3>

      <div class="mb-10">
        <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-4">
          {{ t('labels.floorMaterial') }}
        </div>
        <div class="flex flex-row flex-wrap gap-4">
          <label class="visual-checkbox flex flex-col" for="tile">
            <input
              (click)="onFloorMaterialClick(floorMaterial.Tile)"
              [checked]="(constructionFormGroup.controls.floorMaterial.value ?? []).indexOf(floorMaterial.Tile) > -1"
              class="opacity-0 absolute h-0 w-0"
              id="tile"
              type="checkbox">
            <span class="">{{ 'shared.enum.floorMaterial.' + floorMaterial.Tile | transloco }}</span>
          </label>

          <label class="visual-checkbox flex flex-col" for="wooden">
            <input
              (click)="onFloorMaterialClick(floorMaterial.Wooden)"
              [checked]="(constructionFormGroup.controls.floorMaterial.value ?? []).indexOf(floorMaterial.Wooden) > -1"
              class="opacity-0 absolute h-0 w-0"
              id="wooden"
              type="checkbox">
            <span class="">{{ 'shared.enum.floorMaterial.' + floorMaterial.Wooden | transloco }}</span>
          </label>

          <label class="visual-checkbox flex flex-col" for="luminate">
            <input
              (click)="onFloorMaterialClick(floorMaterial.Laminate)"
              [checked]="(constructionFormGroup.controls.floorMaterial.value ?? []).indexOf(floorMaterial.Laminate) > -1"
              class="opacity-0 absolute h-0 w-0"
              id="luminate"
              type="checkbox">
            <span class="">{{ 'shared.enum.floorMaterial.' + floorMaterial.Laminate | transloco }}</span>
          </label>

          <label class="visual-checkbox flex flex-col" for="marble">
            <input
              (click)="onFloorMaterialClick(floorMaterial.Marble)"
              [checked]="(constructionFormGroup.controls.floorMaterial.value ?? []).indexOf(floorMaterial.Marble) > -1"
              class="opacity-0 absolute h-0 w-0"
              id="marble"
              type="checkbox">
            <span class="">{{ 'shared.enum.floorMaterial.' + floorMaterial.Marble | transloco }}</span>
          </label>

          <label class="visual-checkbox flex flex-col" for="Carpet">
            <input
              (click)="onFloorMaterialClick(floorMaterial.Carpet)"
              [checked]="(constructionFormGroup.controls.floorMaterial.value ?? []).indexOf(floorMaterial.Carpet) > -1"
              class="opacity-0 absolute h-0 w-0"
              id="Carpet"
              type="checkbox">
            <span class="">{{ 'shared.enum.floorMaterial.' + floorMaterial.Carpet | transloco }}</span>
          </label>

          <label class="visual-checkbox flex flex-col" for="Vinyl">
            <input
              (click)="onFloorMaterialClick(floorMaterial.Vinyl)"
              [checked]="(constructionFormGroup.controls.floorMaterial.value ?? []).indexOf(floorMaterial.Vinyl) > -1"
              class="opacity-0 absolute h-0 w-0"
              id="Vinyl"
              type="checkbox">
            <span class="">{{ 'shared.enum.floorMaterial.' + floorMaterial.Vinyl | transloco }}</span>
          </label>

        </div>
      </div>

      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-6">
        {{ t('labels.propertyCondition') }}
      </div>
      <div class="flex flex-row flex-wrap gap-4">

        <!-- <label class="visual-checkbox flex flex-col" for="conditionCompleted">
          <input
            (click)="constructionFormGroup.controls.condition.setValue(constructionFormGroup.controls.condition.value == propertyCondition.Completed ? null : propertyCondition.Completed)"
            [checked]="constructionFormGroup.controls.condition.value == propertyCondition.Completed"
            class="opacity-0 absolute h-0 w-0"
            id="conditionCompleted"
            type="checkbox">
          <span class="">{{ 'shared.enum.propertyCondition.' + propertyCondition.Completed | transloco }}</span>
        </label> -->
        <label class="visual-checkbox flex flex-col" for="conditionGood">
          <input
            (click)="constructionFormGroup.controls.condition.setValue(constructionFormGroup.controls.condition.value == propertyCondition.Good ? null : propertyCondition.Good)"
            [checked]="constructionFormGroup.controls.condition.value == propertyCondition.Good"
            class="opacity-0 absolute h-0 w-0"
            id="conditionGood"
            type="checkbox">
          <span class="">{{ 'shared.enum.propertyCondition.' + propertyCondition.Good | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="conditionNeedsRenovation">
          <input
            (click)="constructionFormGroup.controls.condition.setValue(constructionFormGroup.controls.condition.value == propertyCondition.NeedsRenovation ? null : propertyCondition.NeedsRenovation)"
            [checked]="constructionFormGroup.controls.condition.value == propertyCondition.NeedsRenovation"
            class="opacity-0 absolute h-0 w-0"
            id="conditionNeedsRenovation"
            type="checkbox">
          <span class="">{{ 'shared.enum.propertyCondition.' + propertyCondition.NeedsRenovation | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="conditionIncomplete">
          <input
            (click)="constructionFormGroup.controls.condition.setValue(constructionFormGroup.controls.condition.value == propertyCondition.Incomplete ? null : propertyCondition.Incomplete)"
            [checked]="constructionFormGroup.controls.condition.value == propertyCondition.Incomplete"
            class="opacity-0 absolute h-0 w-0"
            id="conditionIncomplete"
            type="checkbox">
          <span class="">{{ 'shared.enum.propertyCondition.' + propertyCondition.Incomplete | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="conditionRenovated">
          <input
            (click)="constructionFormGroup.controls.condition.setValue(constructionFormGroup.controls.condition.value == propertyCondition.Renovated ? null : propertyCondition.Renovated)"
            [checked]="constructionFormGroup.controls.condition.value == propertyCondition.Renovated"
            class="opacity-0 absolute h-0 w-0"
            id="conditionRenovated"
            type="checkbox">
          <span class="">{{ 'shared.enum.propertyCondition.' + propertyCondition.Renovated | transloco }}</span>
        </label>

        <label class="visual-checkbox flex flex-col" for="conditionNewlyBuilt">
          <input
            (click)="constructionFormGroup.controls.condition.setValue(constructionFormGroup.controls.condition.value == propertyCondition.NewlyBuilt ? null : propertyCondition.NewlyBuilt)"
            [checked]="constructionFormGroup.controls.condition.value == propertyCondition.NewlyBuilt"
            class="opacity-0 absolute h-0 w-0"
            id="conditionNewlyBuilt"
            type="checkbox">
          <span class="">{{ 'shared.enum.propertyCondition.' + propertyCondition.NewlyBuilt | transloco }}</span>
        </label>

        <!-- <label class="visual-checkbox flex flex-col" for="conditionExcellent">
          <input
            (click)="constructionFormGroup.controls.condition.setValue(constructionFormGroup.controls.condition.value == propertyCondition.Excellent ? null : propertyCondition.Excellent)"
            [checked]="constructionFormGroup.controls.condition.value == propertyCondition.Excellent"
            class="opacity-0 absolute h-0 w-0"
            id="conditionExcellent"
            type="checkbox">
          <span class="">{{ 'shared.enum.propertyCondition.' + propertyCondition.Excellent | transloco }}</span>
        </label> -->

      </div>
    </div>
  </div>
</div>
